/**
 * This module is pretty pointless. It just removes some irrelevant boilerplate from the actual code.
 */
export default function options(optionsInput) {
  let data = JSON.parse(optionsInput.value);

  return {
    // get is unnecessary

    set: (k, v) => {
      data[k] = v;

      optionsInput.value = JSON.stringify(data);
    }
  }
}
